var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cd)?_c('div',{staticClass:"c-countdown"},[_vm._t("default"),_c('span',[_vm._v(_vm._s(_vm.cd.day)+"天"+_vm._s(_vm.cd.hour)+"时"+_vm._s(_vm.cd.min)+"分"+_vm._s(_vm.cd.sec)+"秒")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }